module.exports = __webpack_public_path__ + "img/emo_59.453882ea.png";